<template>
  <section id="ronde" class="content">
    <message
      :obj=rondes.message
      hide-mutation-type="CLEAR_RONDE_MESSAGE">
    </message>

    <section class="content-toolbar">
      <div class="btn btn-primary" v-on:click="addDebutJalon(disableDebutJalonBtn())"
           :disabled="disableDebutJalonBtn()">Début de jalon
      </div>
      <div class="btn btn-primary" v-on:click="addFinJalon(disableFinJalonBtn())" :disabled="disableFinJalonBtn()">Fin
        de jalon
      </div>
      <div class="btn btn-primary" v-on:click="showAjoutInterventionModal()">Ajouter une intervention</div>
    </section>

    <ronde-intervention-details-modal
      v-if="rondes.interventionDetailModal.intervention !== null"
      hide-dispatch-action="closeDetailModalForIntervention"
      :intervention="rondes.interventionDetailModal.intervention"
      :ronde="ronde">
    </ronde-intervention-details-modal>

    <ronde-intervention-ajout-modal
      v-if="rondes.ajoutInterventionModal.visible"
      hide-dispatch-action="closeAjoutInterventionModal"
      :ronde="ronde">
    </ronde-intervention-ajout-modal>

    <ronde-debut-fin-jalon-delete-modal
      v-if="rondes.deleteDebutFinJalonModal.visible"
      hide-dispatch-action="closeModalForDebutFinJalonDelete"
      :intervention="rondes.deleteDebutFinJalonModal.intervention"
      :ronde="ronde">
    </ronde-debut-fin-jalon-delete-modal>

    <Draggable :multi-drag="true" animation='150'
               ghostClass="sortable-ghost"
               selected-class="selected-item"
               :key="componentKey"
               :list="this.ronde.data.interventions"
               :group="{ name: 'people', pull: 'clone', put: true }"
               @end="onSorted">
      <content-row
        v-for="(intervention,i) in this.ronde.data.interventions"
        :key="i"
        :not-openable="true"
        :id="intervention.order"
        :select="true"
        :select-disabled="intervention.adresse === undefined && !intervention.jalon"
        @select="showDetailModalForIntervention(intervention)">

        <exit-return-image
          id=".my-handle"
          slot="left-images"
          :is-exit="intervention.sortieBacs"
          v-if="!intervention.jalon">
        </exit-return-image>

        <div slot="main" v-if="intervention.jalon" class="jalon">
          <div class="col-sm-12">
            <span class="text-item jalon">
              {{ intervention.jalon.type }}
            </span>
          </div>
        </div>
        <div slot="main">
          <div class="col-sm-1" v-if="intervention.adresse !== undefined">
            <div class="index-item-wrapper">
              <div class="index-item">
                <span class="title-item">N°</span>
                <span class="text-item text-item--sm">{{ reorganizeOrdres(intervention) + 1 }}</span>
              </div>
            </div>
          </div>
          <div class="col-sm-5 left-separator right-separator" v-if="!intervention.jalon">
            <span class="title-item">ADRESSE</span>
            <span class="text-item"
                  v-if="intervention.adresse !== undefined">
              {{ intervention.adresse.numero }} {{ intervention.adresse.voie }} {{ intervention.adresse.ville }}
            </span>
          </div>
          <div class="col-sm-3 right-separator" v-if="!intervention.jalon">
            <span class="title-item">BACS</span>
            <span class="text-item text-item--sm">
              <img src="/static/img/poubelle-grise.svg"/> {{ intervention.adresse.bacsOm }} OM
              <img src="/static/img/poubelle-jaune.svg"/> {{ intervention.adresse.bacsCs }} CS
            </span>
          </div>
          <div class="col-sm-3" v-if="!intervention.jalon">
            <span class="title-item">STATUT</span>
            <span class="text-item text-item--sm">
              <div class="sortie_rentree_tag" :class="(intervention.sortieBacs)?'sortie':'rentree'">
                {{ (intervention.sortieBacs) ? 'sortie' : 'rentrée' }}
              </div>
              {{
                intervention.sortieBacs ? `${intervention.adresse.heureDebutSortie ? intervention.adresse.heureDebutSortie : '??'} -- ${intervention.adresse.heureFinSortie ? intervention.adresse.heureFinSortie : '??'}` : `${intervention.adresse.heureDebutRentree ? intervention.adresse.heureDebutRentree : '??'} -- ${intervention.adresse.heureFinRentree ? intervention.adresse.heureFinRentree : '??'}`
              }}
            </span>
          </div>
        </div>
      </content-row>
    </Draggable>

    <div class="loading-overlay" v-if="ronde.loadingInterventionsPositions">
      Chargement ...
    </div>

  </section>
</template>

<script>
import _ from 'lodash'
import {mapState} from 'vuex'
import ContentRow from '../../shared/ContentRow'
import Draggable from 'vuedraggable'
import ExitReturnImage from './ExitReturnImage'
import RondeInterventionAjoutModal from './RondeInterventionAjoutModal'
import RondeInterventionDetailsModal from './RondeInterventionDetailsModal'
import RondeDebutFinJalonDeleteModal from './RondeDebutFinJalonDeleteModal'
import Message from '../../shared/Message'

export default {
  components: {
    ContentRow,
    Message,
    Draggable,
    ExitReturnImage,
    RondeInterventionAjoutModal,
    RondeInterventionDetailsModal,
    RondeDebutFinJalonDeleteModal,
  },
  data () {
    return {
      componentKey: 0,
    }
  },
  computed: {
    ...mapState([
      'rondes',
      'ronde'
    ]),
  },
  mounted: async function () {
    await this.$store.dispatch('fetchJalonsV2')
    await this.$store.dispatch('fetchInterventionsOfRondeV2', {
      id: this.$route.params.id,
    })
  },
  beforeDestroy() {
    console.log("Leaving the page - Perform cleanup here");
    this.ronde.data = {}
  },
  methods: {
    showDetailModalForIntervention: function (intervention) {
      if (intervention.adresse !== undefined) {
        this.$store.state.ronde.intervention =_.cloneDeep(intervention)
        this.$store.dispatch('showDetailModalForInterventionV2', intervention)
      } else if (intervention.jalon !== undefined) {
        this.$store.dispatch('showModalForDebutFinJalonV2', intervention)
      }
    },
    showAjoutInterventionModal: function () {
      this.$store.dispatch('showAjoutInterventionModalV2')
    },
    onSorted: function (event) {
      this.$store.dispatch('switchInterventionsPositionsV2', {
        ronde: _.cloneDeep(this.ronde.data),
        first: event.newIndex,
        last: event.oldIndex
      })
      // actualisé le componant pour mettre a jour les id sur la vue
      this.componentKey++
    },
    addDebutJalon: function (isDisabled) {
      if (!isDisabled) {
        console.log('Add Debut Jalon : ')
        if (this.ronde && this.ronde.data.interventions) {
          let index = 0
          if (this.ronde.data.interventions.length > 0) {
            this.ronde.data.interventions.forEach(intervention => {
              if (intervention.jalon && intervention.jalon.type === 'Fin de jalon') {
                index = intervention.order + 1
              }
            })
            this.$store.dispatch('addDebutOuFinJalonV2', {
              ronde: _.cloneDeep(this.ronde.data),
              index: index,
              type: "Début de jalon",
            })
          } else {
            this.$store.dispatch('addDebutOuFinJalonV2', {
              ronde: _.cloneDeep(this.ronde.data),
              index: index,
              type: "Début de jalon",
            })
          }
        }
      }
    },
    addFinJalon: function (isDisabled) {

      if (!isDisabled) {
        if (this.ronde && this.ronde.data.interventions) {
          let index = 0
          if (this.ronde.data.interventions.length > 0) {
            this.ronde.data.interventions.forEach(intervention => {
              if (intervention.jalon && intervention.jalon.type === 'Début de jalon') {
                index = intervention.order + 1
              }
            })
            this.$store.dispatch('addDebutOuFinJalonV2', {
              ronde: _.cloneDeep(this.ronde.data),
              index: index,
              type: "Fin de jalon",
            })
          } else {
            this.$store.dispatch('addDebutOuFinJalonV2', {
              ronde: _.cloneDeep(this.ronde.data),
              index: index,
              type: "Fin de jalon",
            })
          }
        }
      }
    },
    disableDebutJalonBtn: function () {
      let shouldDisableBtn = false
      if (this.ronde && this.ronde.data.interventions) {
        if (this.ronde.data.interventions.length > 0) {
          this.ronde.data.interventions.forEach(intervention => {
            // DEBUT JALON = 0, FIN JALON = 1
            if (intervention.jalon) {
              if (intervention.jalon.type === 'Début de jalon') {
                shouldDisableBtn = true
              } else {
                shouldDisableBtn = false
              }
            }
          })
          return shouldDisableBtn
        }
      } else {
        return !shouldDisableBtn
      }
      return false
    },
    disableFinJalonBtn: function () {
      let shouldDisableBtn = false
      let noJalon = true
      if (this.ronde && this.ronde.data.interventions) {
        if (this.ronde.data.interventions.length > 0) {
          this.ronde.data.interventions.forEach(intervention => {
            // DEBUT JALON = 0, FIN JALON = 1
            if (intervention.jalon) {
              noJalon = false
              if (intervention.jalon.type === 'Fin de jalon') {
                shouldDisableBtn = true
              } else {
                shouldDisableBtn = false
              }
            }
          })
          // return shouldDisableBtn
          if (noJalon) {
            return !shouldDisableBtn
          } else {
            return shouldDisableBtn
          }
        }
      } else {
        return !shouldDisableBtn
      }
      return false
    },
    reorganizeOrdres: function (intervention) {
      let fakeAddresses = 0
      let order = 0
      this.ronde.data.interventions.forEach(value => {
        if (value.jalon === undefined && value.order === intervention.order) {
          order = value.order - fakeAddresses
        } else if (value.jalon !== undefined) {
          fakeAddresses++
        }
      })
      return order
    },
  },
}
</script>

<style lang="scss">
@import "../../../scss/variables";

#ronde {

  .selected-item {
    color: red !important;
    background: blue !important;
    background-color: white !important;;

  }

  .contentRow {
    cursor: move;
  }

  .sortable-ghost {
    border-radius: 3px;
    border: 2px dashed $suez-blue;
  }

  .index-item-wrapper {
    display: flex;
    align-items: center;

    .index-item {
      padding-left: 15px;
    }
  }

  .sortie_rentree_tag {
    color: white;
    border-radius: 4px;
    background-color: $sortie;
    display: inline-block;
    text-transform: uppercase;
    font-size: .8em;
    padding: 2px 5px;
    font-weight: bold;

    &.rentree {
      background-color: $rentree;
    }
  }

  .jalon {
    font-size: 20px;
    text-align: center;
  }

}

</style>



// WEBPACK FOOTER //
// Ronde.vue?206ad930